import { css } from "emotion";
import Button from "../../../../components/global/Button";
import SignUpButton from "../../../../components/global/SignUpButton";
import H3 from "../../../../components/global/H3";
import P from "../../../../components/global/P";
import Image from "../../../../components/Image";
import ContentBlock from "../../../../components/layout/ContentBlock";
import { lastOfType, max } from "../../../../utils/CssUtils";
import FlexColumn from "./FlexColumn";

const SmileLogo = require("../../../../assets/humanitixFaces/smile_teal.svg");

const buttonWrapper = css({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "wrap",
  marginTop: 12,
  a: {
    marginRight: 8,
    [lastOfType()]: {
      marginRight: 0
    }
  },
  [max(600)]: {
    marginTop: 4,
    button: {
      width: 140
    }
  }
});

const contentWrapper = css({
  margin: "auto",
  textAlign: "center",
  maxWidth: 500,
  img: {
    marginBottom: 8,
    maxWidth: 60
  },
  h3: {
    color: "white",
    marginBottom: 16
  },
  p: {
    color: "white",
    marginBottom: 12
  },
  [max(600)]: {
    minWidth: 292,
    h3: {
      marginBottom: 12
    },
    img: {
      marginBottom: 12
    }
  }
});

const HowToHelp = ({ text, localeData }) => (
  <ContentBlock color="purple">
    <FlexColumn className={contentWrapper}>
      <Image imageURL={SmileLogo} alt="Humanitix Logo - teal smile :)" />
      <H3>How you can help</H3>
      <P>{text}</P>
      <div className={buttonWrapper}>
        <SignUpButton type="secondary" size="large" aria-label="Sign up">
          Run an event
        </SignUpButton>
        <Button
          type="secondary"
          size="large"
          style="hollow"
          link={`/${localeData.locale}/search`}
          ariaLabel="Get ticket"
        >
          Get a ticket
        </Button>
      </div>
    </FlexColumn>
  </ContentBlock>
);

export default HowToHelp;
